module.exports = __webpack_public_path__ + "static/media/githublogo.c963626c.png";